<div class="filter-item p-2" *ngIf="(selectedFilter[selectedFilterId]?.filter)!.type; else noOptions">
   <p class="text-400 text-base">
      {{ (selectedFilter[selectedFilterId]?.filter)!.label }}
   </p>
   <ng-container *ngIf="selectedFilter[selectedFilterId]?.filter?.type; else noOptions">
      <ng-container [ngSwitch]="(selectedFilter[selectedFilterId]?.filter)!.type">
         <!-- Checkbox Filter -->
         <div *ngSwitchCase="FilterType.Checkbox" class="flex flex-column gap-2">
            <div *ngFor="let option of options" class="field-checkbox align-items-start flex flex-column">
               <div class="flex flex-row gap-1 align-items-center">
                  <p-checkbox
                     [inputId]="(selectedFilter[selectedFilterId]?.filter)!.id + '_' + option.value"
                     [name]="(selectedFilter[selectedFilterId]?.filter)!.id"
                     [value]="option.value"
                     [(ngModel)]="selectedFilter[selectedFilterId].value"
                     (onChange)="onValueChange((selectedFilter[selectedFilterId]?.filter)!.id, $event.checked)"
                  >
                  </p-checkbox>
                  <label [for]="(selectedFilter[selectedFilterId]?.filter)!.id + '_' + option.value" class="ml-2">
                     {{ option.label }}
                  </label>
               </div>
               <small class="text-500 block ml-5 max-width-checkboxes">{{ option.description }}</small>
            </div>
         </div>

         <!-- Dropdown Filter -->
         <p-dropdown
            *ngSwitchCase="FilterType.Dropdown"
            [options]="options"
            optionLabel="label"
            optionValue="value"
            [placeholder]="
               'DATA.COMMON.ACTIONS.SELECT_PLACEHOLDER'
                  | translate: { placeholder: (selectedFilter[selectedFilterId]?.filter)!.label }
            "
            [(ngModel)]="selectedFilter[selectedFilterId].value"
            (onChange)="onValueChange(selectedFilterId, $event.value)"
            styleClass="w-full md:w-80"
            class="w-full md:w-80"
         >
         </p-dropdown>

         <!-- Multiselect Filter -->
         <p-multiSelect
            *ngSwitchCase="FilterType.Multiselect"
            [options]="options"
            optionLabel="label"
            optionValue="value"
            [placeholder]="
               'DATA.COMMON.ACTIONS.SELECT_PLACEHOLDER'
                  | translate: { placeholder: (selectedFilter[selectedFilterId]?.filter)!.label }
            "
            [maxSelectedLabels]="3"
            [(ngModel)]="selectedFilter[selectedFilterId].value"
            (onChange)="onValueChange((selectedFilter[selectedFilterId]?.filter)!.id, $event.value)"
            styleClass="w-full md:w-80"
            class="w-full md:w-80"
         >
         </p-multiSelect>

         <!-- TreeSelect Filter -->
         <p-treeSelect
            *ngSwitchCase="FilterType.TreeSelect"
            [placeholder]="'Select...' + (selectedFilter[selectedFilterId]?.filter)!.label"
            [(ngModel)]="selectedFilter[selectedFilterId].value"
            [options]="options"
            [metaKeySelection]="false"
            containerStyleClass="w-full"
            selectionMode="checkbox"
            filter="true"
            (ngModelChange)="onValueChange((selectedFilter[selectedFilterId]?.filter)!.id, $event.value)"
            class="w-full md:w-80"
         ></p-treeSelect>

         <!-- Input Filter -->
         <input
            type="text"
            pInputText
            *ngSwitchCase="FilterType.Input"
            [(ngModel)]="selectedFilter[selectedFilterId].value"
            (ngModelChange)="emitSimpleFilter((selectedFilter[selectedFilterId]?.filter)!.id, $event)"
            [placeholder]="'Entra ' + (selectedFilter[selectedFilterId]?.filter)!.label"
            class="w-full md:w-80"
         />

         <!-- Chip Filter -->
         <div *ngSwitchCase="FilterType.Chips" class="flex flex-column gap-2">
            <app-chips-filter
               [id]="'chips_' + (selectedFilter[selectedFilterId]?.filter)!.id + '_' + selectedFilterId"
               [filter]="selectedFilter[selectedFilterId]"
               (filterChange)="emitComplexToParent($event)"
               class="w-full md:w-80"
            ></app-chips-filter>
         </div>

         <!-- Range Filter -->
         <div *ngSwitchCase="FilterType.Range" class="flex flex-column gap-2">
            <app-range-filter
               *ngSwitchCase="FilterType.Range"
               [filter]="selectedFilter[selectedFilterId]"
               (filterChange)="emitComplexToParent($event)"
               class="w-full md:w-80"
            ></app-range-filter>
         </div>

         <!-- Composed Filter -->
         <div *ngSwitchCase="FilterType.Composed" class="flex flex-column gap-2">
            <app-multiple-filters
               *ngSwitchCase="FilterType.Composed"
               [filter]="selectedFilter[selectedFilterId]"
               (filterChange)="emitComplexToParent($event)"
               class="w-full md:w-80"
            ></app-multiple-filters>
         </div>

         <!-- Date Range Filter -->
         <div *ngSwitchCase="FilterType.DateRange" class="flex flex-column gap-2">
            <app-date-range-filter
               *ngIf="selectedFilter[selectedFilterId]?.filter?.type === FilterType.DateRange"
               [id]="'date_range_' + (selectedFilter[selectedFilterId]?.filter)!.id + '_' + selectedFilterId"
               [filter]="selectedFilter[selectedFilterId]"
               (filterChange)="emitComplexToParent($event)"
               class="w-full md:w-80"
            ></app-date-range-filter>
         </div>

         <p-messages
            *ngIf="
               selectedFilter[selectedFilterId].filter.tooltip &&
               selectedFilter[selectedFilterId].filter.tooltip?.trim()
            "
            severity="info"
            class="mt-2 message-width"
         >
            <ng-template pTemplate>
               <div class="p-message flex flex-row gap-2 -my-1 mx-1">
                  <span class="pi pi-info-circle p-1"></span>
                  <span [innerHTML]="selectedFilter[selectedFilterId].filter.tooltip"></span>
               </div>
            </ng-template>
         </p-messages>
      </ng-container>
   </ng-container>

   <ng-template #noOptions>
      <!-- Instead of just "No options available", show a skeleton or placeholder during null -->
      <div *ngIf="selectedFilterId == null || selectedFilterId == ''" class="filter-placeholder">Loading filter...</div>
      <p *ngIf="selectedFilterId != null" class="text-500 text-sm">No options available.</p>
   </ng-template>
</div>
<ng-template #noOptions>
   <p class="text-500 text-sm">No options available.</p>
</ng-template>
